<template>
  <div class="view">

	<box label="Mine indstillinger">

    <div class="btn" @click="toggle_show_beta_content">
      <template v-if="show_beta_content">● beta-indhold</template>
      <template v-else>○ beta-indhold</template>
    </div>
    
    <br>
    
    <div class="btn" @click="toggle_show_debug_data_boxes">
      <template v-if="show_debug_data_boxes">● dev debug boxes</template>
      <template v-else>○ dev debug boxes</template>
    </div>

    <br><br>

    <p>Skift theme</p>
    <template v-for="(theme,theme_key) in themes">
      <div class="btn" @click="apply_ui_theme(theme_key)">{{theme_key}}</div>
      <br>
    </template>

    <div class="btn" @click="goto('/tema-editor')">Tema editor</div>
    
    <div class="btn" @click="goto('/kitchensink')">Kitchensink</div>

	</box>

  <box label="Tips & tricks">
    <table class="table-a">
      <tbody>        
        <tr><td>&gt; Tags kan defineres på projekter eller kunde, under instillinger.</td></tr>
        <tr><td>&gt; Projekter tagget 'fakturaklar' markeres klar til fakturering på hjemmeskærmen.</td></tr>
        <tr><td>&gt; Projekter tagget med ens initialer (det før @ i ens Milk mail, f.eks. 'an') vises på ens hjemmeskærm så længe de ikke er afsluttede.</td></tr>
        <tr><td>&gt; Man kan skifte theme ovenfor, eller selv definere ens egne ønskede farver.</td></tr>
        <tr><td>&gt; Beta indhold kan vises/skjules ved klik på knappen ovenfor.</td></tr>
      </tbody>
    </table>    

	</box>

  <box label="debug_output" v-if="debug_output">
    <pre>{{debug_output}}</pre>
  </box>
  
  <box label="WP playground" v-if="is_user('wp')">    
  </box>

  </div>
</template>

<script>
import moment from 'moment'
import fdb from '.././firebase_config.js'
import themes from '../themes.js'
import mixins from '../mixins.js'
import helpers from '../helpers.js'
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
export default {
  data: function () {
    return {
      globals: this.$parent.globals,
      themes,
      debug_output: undefined,
    }
  },
  mixins: [ mixins.db, mixins.generic ],
  computed:{

    projectsMissingAClient(){
      var projects = this.$store.getters['projects/getAll']
      var output = []
      for( let project of projects ) {
        if( !project.client_key ) {
          output.push(project)
          continue
        }
        var c = this.$store.getters['clients/getOne'](project.client_key)
        if( !c ) output.push(project)
      }
      return output
    },

  },
  methods: {

    toggle_show_beta_content(){ this.$store.commit('toggle_show_beta_content') },
    toggle_show_debug_data_boxes(){ this.$store.commit('toggle_show_debug_data_boxes') },

    apply_ui_theme(theme_key){
      eventBus.$emit('apply_ui_theme', { theme_key })
    },


    dbmigrate_215346(){
      console.log('--> DB Migration: all projects with status not finished/active were set to draft')
      var items = this.$store.getters['projects/getAll']
      for( let item of items ) {
        if( item.status === 'finished' ) continue
        if( item.status === 'active' ) continue
        console.log(item.name + ' --- ' + item.status)
        //fdb.ref('projects').child(item.key||item['.key']).update({ status:'draft' })
      }
    },

    dbmigrate_21sdfsdf46(){
      console.log('--> DB Migration: all projects with payment_model undefined were set to fixed_price')
      var items = this.$store.getters['projects/getAll']
      for( let item of items ) {
        if( item.payment_model === 'fixed_price' ) continue
        if( item.payment_model === 'time_expense' ) continue
        fdb.ref('projects').child(item.key||item['.key']).update({ payment_model:'fixed_price' })
      }
    },

    dbmigrate_2sfgd6(){
      console.log('--> DB Migration: archive all projects without a valid client')
      var items = this.$store.getters['projects/getAll']

      items = items.filter((item)=>{
        var client = this.$store.getters['clients/getOne']( item.client_key )
        if( !client ) return false
        return true
      })

      this.debug_output = items
      return

      for( let item of items ) {
        console.log(item.name + ' --- ' + item.status)
        //fdb.ref('projects').child(item.key||item['.key']).update({ status:'draft' })
      }

    },

    dbmigrate_2esffwqfd(){
      console.log('--> DB Migration: change all timelogs from stringdate to unix')
      var i = 0

      var fdb_updates = {}

      var items = this.getAll('timelogs').filter((e)=> ( e.created && !e.created_timestamp ) )
      
      for( let item of items ) {
        //if( item.date_timestamp ) continue
        let key = item.key || item._key || item['.key']
        if( !key ) continue        

        if( item.date && !item.date_timestamp ) {
          //fdb_updates['timelogs/'+key+'/date_timestamp'] = moment(item.date,'YYYY-MM-DD').unix()
        }

        if( item.created && !item.created_timestamp ) {
          fdb_updates['timelogs/'+key+'/created_timestamp'] = moment(item.created,'YYYY-MM-DD hh:mm:SS').unix()
        }

        i++
        if( i > 100000 ) {
          console.log('max processed')
          break
        }
      }

      
      console.log(fdb_updates)
      //fdb.ref('/').update(fdb_updates); console.log('DB updated!')

    },


    dbmigrate(){
      //this.dbmigrate_215346()
      //this.dbmigrate_2sfgd6()
      //this.dbmigrate_21sdfsdf46()
      //this.dbmigrate_2esffwqfd()
    },


  },//methods

  created(){
    this.dbmigrate()

  },

  components: { Box, Btn, Avatar },
}
</script>



// WEBPACK FOOTER //
// Mysettings.vue?40e5134f